import { Link } from 'react-router-dom'
import { useProjects } from './useProjects'

export function ProjectListPage() {
  const { data, isLoading, isError, error } = useProjects()

  if (isLoading) return <p className="text-surface-400">Loading projects…</p>
  if (isError) {
    return (
      <p className="text-rose-400">
        Could not load projects: {error instanceof Error ? error.message : 'unknown error'}
      </p>
    )
  }
  if (!data || data.length === 0) {
    return (
      <div className="text-surface-400">
        <p className="mb-2">No projects assigned to your account.</p>
        <p className="text-sm">
          The demo sandbox resets periodically. Sign in as another role to explore other views.
        </p>
      </div>
    )
  }

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Projects</h1>
      <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {data.map((p) => (
          <li key={p.id}>
            <Link
              to={`/projects/${p.id}`}
              className="block rounded-xl border border-surface-700 bg-surface-900 p-5 hover:border-accent-500 transition"
            >
              <div className="font-semibold">{p.name}</div>
              {p.status && (
                <div className="text-xs text-surface-400 mt-1">Status: {p.status}</div>
              )}
              {p.primary_site_lead_name && (
                <div className="text-xs text-surface-400">
                  Lead: {p.primary_site_lead_name}
                </div>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export function ProjectDetailPage() {
  return (
    <div className="text-surface-400">
      <h1 className="text-2xl font-bold mb-2 text-surface-100">Project detail</h1>
      <p>Workflow screens land in spec 05.</p>
    </div>
  )
}
